import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FaMapMarkerAlt, FaPhone, FaInstagram, FaYoutube, FaTiktok } from 'react-icons/fa';
import './TopBar.css';

const TopBar = () => {
    const [contactInfo, setContactInfo] = useState({
        address: '',
        contactPhone: '',
        instagramUrl: '',
        tiktokUrl: '',
        youtubeUrl: ''
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchContactInfo = async () => {
            try {
                const docRef = doc(db, "settings", "siteConfig");
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setContactInfo({
                        address: data.address || '',
                        contactPhone: data.contactPhone || '',
                        instagramUrl: data.instagramUrl || 'https://www.instagram.com/official_smkparsmb/',
                        tiktokUrl: data.tiktokUrl || 'https://www.tiktok.com/@pariwisatasumbangsih',
                        youtubeUrl: data.youtubeUrl || 'https://www.youtube.com/c/SMKPARIWISATASUMBANGSIH',
                    });
                }
            } catch (error) {
                console.error("Gagal mengambil info kontak untuk TopBar:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchContactInfo();
    }, []);

    if (loading) {
        return <div className="top-bar-skeleton"></div>;
    }

    return (
        <div className="top-bar">
            <div className="container top-bar-container">
                <div className="top-bar-left">
                    <FaMapMarkerAlt />
                    <span>{contactInfo.address}</span>
                </div>
                <div className="top-bar-right">
                    <a href={`tel:${contactInfo.contactPhone}`} className="top-bar-phone"><FaPhone /> {contactInfo.contactPhone}</a>
                    <a href={contactInfo.instagramUrl} target="https://www.instagram.com/official_smkparsmb/" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                    <a href={contactInfo.tiktokUrl} target="https://www.tiktok.com/@pariwisatasumbangsih" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok /></a>
                    <a href={contactInfo.youtubeUrl} target="https://www.youtube.com/c/SMKPARIWISATASUMBANGSIH" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
                </div>
            </div>
        </div>
    );
};

export default TopBar;